import React from 'react';
import { NavLink } from 'react-router-dom';
export default function WhatsAppSettingsNav({ knowledgeEnabled = true }) {
 const items=[['/settings/whatsapp','Overview'],...(knowledgeEnabled?[['/settings/business-knowledge','Business knowledge']]:[])];
 return <nav aria-label="WhatsApp settings" className="flex flex-wrap gap-2">{items.map(([to,label])=><NavLink key={to} to={to} end className={({isActive})=>`rounded-lg border px-3 py-2 text-sm font-medium ${isActive?'border-primary-200 bg-primary-50 text-primary-700':'border-gray-200 bg-white text-gray-600'}`}>{label}</NavLink>)}</nav>;
}
